import { Footer } from "../container";
//import FooterBook from "../container/FooterBook/FooterBook";
import HeaderBook from "../container/LibroAzul/HeaderBook/HeaderBook";
import NavbarBook from "../container/LibroAzul/NavBarBook/NavBarBook";
import Home_cinco from "../container/Home/home_cinco/libro_azul_more/Libro_azul_more";
import Navbar from '../container/navbar/Navbar'
import {NLV_Coleccion} from '../container';



import styles from '../container/LibroAzul/BookBlue.module.scss'

import { PopupProvider } from "../context/PopupProvider";
import { useContext } from "react";
import { PopupContext } from "../context/PopupContext";
import { PopupContainer } from "../container/LibroAzul/PopupContainer/PopupContainer";


const LibroAzul = () => {

    return (
        <PopupProvider>
            <div className={`${styles.Background} ${styles.Background_BookBlue}`}>
                <PopupContainer />
                <Navbar link='https://www.amazon.com.mx/Ideas-transforman-negocios-cambiar-mundo/dp/607596732X/ref=sr_1_1?__mk_es_MX=%C3%85M%C3%85%C5%BD%C3%95%C3%91&crid=K2T1OGRX0TJB&keywords=ideas+que+transforman+negocios+para+cambiar+el+mundo&qid=1697498981&s=books&sprefix=ideas+que+transforman+negocios+para+cambiar+el+mundo%2Cstripbooks%2C283&sr=1-1'/>
                <HeaderBook />
                <NLV_Coleccion/>
                <Home_cinco/>
                <Footer />
            </div>
        </PopupProvider>
    );

}

export default LibroAzul;